import { module } from 'modujs';
import { load as loadRecaptcha } from 'recaptcha-v3';
import { CUSTOM_EVENT } from '../config';

export default class extends module {
    constructor(m) {
        super(m);

        this.recaptchaPubkey = this.getData('recaptcha-pubkey');

        this.$feedback = this.$('feedback')[0]

        this.events = {
            submit: "onSubmit"
        }
    }

    async onSubmit(e) {
        e.preventDefault()
        e.stopPropagation()

        if(this.isLoading) return;

        const formData = new FormData(this.el);

        this.formErrors = false
        this.feedback(false);
        this.setLoading()

        if(this.recaptchaPubkey) {
            // Handle recaptcha
            const recaptcha = await loadRecaptcha(this.recaptchaPubkey, {
                autoHideBadge: true
            })

            const token = await recaptcha.execute()
            formData.append('g-recaptcha-response', token);
        }

        // This is based on https://25ans.hema-quebec.qc.ca/fr/temoignages by @pascalrioux

        fetch(this.el.action, {
            method: 'POST',
            body: formData,
        })
        .then(response => response.json())
        .then(response => {
            // console.log(response);
            if (!response.ok) {
                throw this.formErrors = response.errors;
            }
        }).catch((e) => {
            console.error(e)

            if(!this.formErrors) this.formErrors = [this.getData('unexpected-error')];
            this.feedback(this.formErrors.map(error => error.message).join('<br>'), 'error')

        }).finally(() => {
            this.setLoading(false)

            if (!this.formErrors) {
                this.feedback(this.getData('success-feedback'))
                this.reset()
            }
        });
    }

    setLoading(value = true) {
        this.isLoading = value;
        this.el.classList.toggle('is-loading', this.isLoading);
    }

    feedback(message, type = 'success') {
        if(!message) {
            this.$feedback.classList.add('u-none');
            return;
        } else this.$feedback.classList.remove('u-none');

        this.$feedback.innerHTML = message
        for(let modifier of ['error', 'success']) this.$feedback.classList.remove('-'+modifier);
        this.$feedback.classList.toggle('-'+type);
    }

    reset() {
        this.el.reset()
        window.dispatchEvent(new CustomEvent(CUSTOM_EVENT.FORM_RESET, {
            detail: {
                form: this.el
            }
        }))
    }
}
